import React, { createContext, useState, useContext } from "react";
import {
  fetchQuestionsData,
  fetchQuestionsDataWithSection,
} from "../services/service";
import { decryptData } from "../crypto";
import { useMediaQuery } from "@mui/material";

const QuestionContext = createContext();

function QuestionProvider({ children }) {
  const [question, setQuestion] = useState(null);

  const isMobile = useMediaQuery("(max-width:599px)");
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:768px)");

  function convertMinutesToTimeFormat(totalMinutes) {
    let hours = Math.floor(totalMinutes / 60);
    let minutes = totalMinutes % 60;
    let seconds = 0;

    // Format with leading zeros
    let formattedTime =
      String(hours).padStart(2, "0") +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(seconds).padStart(2, "0");

    return formattedTime;
  }

  const fetchQuestions = async (examId) => {
    // if (question) return;

    try {
      let questionsData = {};
      if (
        decryptData(sessionStorage.getItem("exam_template")) ===
          "ssc/railway" ||
        decryptData(sessionStorage.getItem("exam_template")) === "ipmat"
      ) {
        questionsData = await fetchQuestionsDataWithSection(examId);
      } else {
        questionsData = await fetchQuestionsData(examId);
      }
      setQuestion(questionsData);
      const storedExamDuration = questionsData.duration;
      sessionStorage.setItem(
        "examDuration",
        convertMinutesToTimeFormat(Number(storedExamDuration))
      );
      sessionStorage.setItem("subject_wise", questionsData.subject_wise);
      sessionStorage.setItem("is_submit_on_time", questionsData.is_submit_on_time);    
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  return (
    <QuestionContext.Provider value={{ question, fetchQuestions }}>
      {children}
    </QuestionContext.Provider>
  );
}

const useQuestion = () => {
  return useContext(QuestionContext);
};

export { useQuestion };
export default QuestionProvider;
